import { useEffect, useState } from "react";
import { fetchLaunchOffer, unlockLaunchOffer } from "../../lib/api";

const key = (slug) => `cled_offer_${slug}`;
const read = (slug) => { try { return JSON.parse(localStorage.getItem(key(slug))); } catch { return null; } };

export function useLaunchOffer(slug, sessionId, finished) {
  const [settings, setSettings] = useState(null);
  const [offer, setOffer] = useState(() => read(slug));
  const [now, setNow] = useState(Date.now());
  useEffect(() => { fetchLaunchOffer().then(setSettings).catch(() => setSettings({ enabled: false })); }, []);
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(t); }, []);
  useEffect(() => {
    if (!settings?.enabled || !finished || !sessionId || read(slug)) return;
    unlockLaunchOffer(sessionId).then((o) => { localStorage.setItem(key(slug), JSON.stringify(o)); setOffer(o); setNow(Date.now()); }).catch(() => {});
  }, [settings, finished, sessionId, slug]);

  if (!settings?.enabled || !offer) return null;
  const left = new Date(offer.expires_at).getTime() - now;
  return left > 0 ? { token: offer.token, percent: settings.percent, left } : null;
}

export const formatLeft = (ms) => {
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return `${h} h ${String(m).padStart(2, "0")} min`;
};
